export default __webpack_public_path__ + "static/media/p6.aaa72575.jpg";